import OnboardingContent from './components/OnboardingContent';
import React from 'react';

// Global onboarding service that can be called from anywhere
export class GlobalOnboardingService {
  private static instance: GlobalOnboardingService;
  private listeners: Array<(content: React.ReactNode) => void> = [];
  private rightPanelControl: any = null;

  private constructor() {}

  static getInstance(): GlobalOnboardingService {
    if (!GlobalOnboardingService.instance) {
      GlobalOnboardingService.instance = new GlobalOnboardingService();
    }
    return GlobalOnboardingService.instance;
  }

  // Set the right panel control (called from AppLayout)
  setRightPanelControl(control: any): void {
    this.rightPanelControl = control;
  }

  // Subscribe to onboarding events
  subscribe(listener: (content: React.ReactNode) => void): () => void {
    this.listeners.push(listener);
    return () => {
      const index = this.listeners.indexOf(listener);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  // Trigger onboarding from anywhere
  showOnboarding(): void {
    // Create onboarding content
    const content = React.createElement(OnboardingContent, {
      onComplete: () => {
        if (this.rightPanelControl) {
          this.rightPanelControl.hideOnboarding();
        }
      }
    });

    // Use right panel control if available
    if (this.rightPanelControl) {
      this.rightPanelControl.showOnboarding(content);
    } else {
      // Fallback: notify listeners
      this.listeners.forEach((listener) => listener(content));
    }
  }

  // Set pending onboarding for next page load
  setPendingOnboarding(): void {
    const pending = {
      timestamp: Date.now()
    };
    localStorage.setItem('pendingOnboarding', JSON.stringify(pending));
  }

  // Trigger onboarding via URL parameter
  triggerViaURL(): void {
    const url = new URL(window.location.href);
    url.searchParams.set('onboarding', 'true');
    window.history.replaceState({}, '', url.toString());

    // Trigger immediately
    this.showOnboarding();
  }
}

// Global instance
export const globalOnboarding = GlobalOnboardingService.getInstance();

// Convenience functions for easy access
export const showOnboarding = () => globalOnboarding.showOnboarding();
export const setPendingOnboarding = () => globalOnboarding.setPendingOnboarding();
export const triggerViaURL = () => globalOnboarding.triggerViaURL();

// Make available globally for easy access
if (typeof window !== 'undefined') {
  (window as any).showOnboarding = showOnboarding;
}
